import { Typography } from '../../Typography';

export interface ErrorMessageProps {
  error?: { message?: string };
}

export function ErrorMessage({ error }: ErrorMessageProps) {
  return (
    <Typography variant="bodySmall" className="text-red-500 mt-1">
      {error ? error.message : ''}
    </Typography>
  );
}
